var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMiniArrowDoubleLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMiniArrowDouble",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1319.1 790.054 1020.06 355.79c-33.165-48.165-87.553-47.273-120.104 0L600.92 790.054c-33.166 48.165-12.581 87.21 46.116 87.21h625.944c58.64 0 78.67-39.938 46.12-87.21ZM600.634 1129.94l299.035 434.27c33.167 48.16 87.554 47.27 120.101 0l299.04-434.27c33.17-48.16 12.58-87.21-46.12-87.21H646.75c-58.636 0-78.668 39.94-46.116 87.21Z"
      }))
    });
  }
}
IconMiniArrowDoubleLine.glyphName = 'mini-arrow-double';
IconMiniArrowDoubleLine.variant = 'Line';
IconMiniArrowDoubleLine.displayName = 'IconMiniArrowDoubleLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMiniArrowDoubleLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMiniArrowDoubleLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMiniArrowDoubleLine;
export { IconMiniArrowDoubleLine };